import type { IconData } from '@stacksjs/iconify-core'

export const contentSave: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M12 0H0v16h16V4zM5 2h6v4H5zM3 12h10v2H3z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentSave
